export default __webpack_public_path__ + "b54b02ed18eac59d4a64d46b02dcf826.png";